<template>
    <div class="download">
        <router-link :to="{ name:'download-home'}" tag="button">
            {{ $t("pages.pricing.info.downloadButton") }}
        </router-link>

        <p>
            <slot></slot>
        </p>
    </div>
</template>

<script>
    export default {
        name: "DownloadButton"
    }
</script>

<style scoped lang="scss">
    @import "../theme/theme";

    .download {
        button {
            user-select: none;
            padding: 0.7em 1em;
            border-radius: 0.4em;
            border-width: 1px;
            border-style: solid;
            min-width: 15em;
            text-decoration: none;
            text-effect: none;
            font-size: 1em;
            cursor: pointer;
            transition-duration: .25s;
            background: $primary100;
            border-color: $back20;
            color: $primaryText100;
            margin-right: 0.5em;
            outline:none;
        }

        button:hover {
            background: $back20;
            border-color: $back20;
            color: $primary10;
        }

        p {
            margin-top: 0.5rem;
            font-weight: 300;
            font-size: 0.8rem;
        }
    }
</style>